import {
  CustomFieldAttributeInterface,
  CustomFieldGroupTemplateInterface,
  CustomFieldInterface,
  CustomFieldTypeInterface
} from '@/interfaces/CustomFields.interface';
import BaseApiClient from '../BaseApiClient';
import { ListDataParams, ListDataResponse } from '../types';

export class ApiCustomFields extends BaseApiClient {
  /**
   * Get all field types i.e. text, number, date, etc.
   */
  async getFieldTypes(): Promise<CustomFieldTypeInterface[]> {
    return new Promise((resolve, reject) => {
      this.client
        .getList(
          '/field-types',
          { page: 1, perPage: 100 },
          { headers: { Version: '2025-11-14' } }
        )
        .then((res) => {
          if (res.data) {
            resolve(res.data.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  /**
   * Get all field attributes i.e. currency, percent etc.
   */
  async getFieldAttributes(): Promise<CustomFieldAttributeInterface[]> {
    return new Promise((resolve, reject) => {
      this.client
        .getList(
          '/field-attributes',
          { page: 1, perPage: 100 },
          { headers: { Version: '2025-11-14' } }
        )
        .then((res) => {
          if (res.data) {
            resolve(res.data.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  /**
   * Get all field group templates i.e. Insurance, Wealth, etc.
   */
  async getFieldGroupTemplates(): Promise<CustomFieldGroupTemplateInterface[]> {
    return new Promise((resolve, reject) => {
      this.client
        .getList(
          '/field-group-templates',
          { page: 1, perPage: 100 },
          { headers: { Version: '2025-11-14' } }
        )
        .then((res) => {
          if (res.data) {
            resolve(res.data.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  /**
   * Create fields for audiences
   */
  async createFieldsForAudiences(payload: {
    fields: {
      id?: number;
      label: string;
      field_type_id: number;
      field_attribute_id?: number;
      options?: string[];
      order: number;
    }[];
  }): Promise<CustomFieldInterface[]> {
    return new Promise((resolve, reject) => {
      this.client
        .put('/fields', payload, { headers: { Version: '2025-11-14' } })
        .then((res) => {
          if (res.data) {
            resolve(res.data.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  /**
   * Get all customer fields
   */
  async getCustomerFields(
    listData: ListDataParams,
    searchTerm?: string
  ): Promise<ListDataResponse<CustomFieldInterface>> {
    return new Promise((resolve, reject) => {
      if (searchTerm) {
        if (!listData.filters) listData.filters = {};
        listData.filters.label = searchTerm;
      }
      this.client
        .getList('/field-groups/customer-fields', listData, {
          headers: { Version: '2025-11-14' }
        })
        .then((res) => {
          if (res.data) {
            resolve({
              items: res.data.data,
              pagination: {
                page: res.data.meta?.current_page,
                perPage: res.data.meta?.per_page,
                total: res.data.meta?.total
              }
            });
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }
}

export { customFieldsQueryKeys } from './query-keys';
export type { CustomFieldsCustomerFieldsParams } from './query-keys';
export {
  useCustomFieldsCustomerFieldsQuery,
  useCustomFieldsFieldAttributesQuery,
  useCustomFieldsFieldGroupTemplatesQuery,
  useCustomFieldsFieldTypesQuery
} from './use-custom-fields-queries';
export { useCustomFieldsCreateFieldsForAudiencesMutation } from './use-custom-fields-mutations';

